import React from 'react';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

export const OfflineBanner: React.FC = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div
      className="sticky top-0 left-0 right-0 z-50 bg-amber-600 text-white text-center py-2 text-sm font-medium"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      You are offline. Some features may be unavailable.
    </div>
  );
};
